<div class="flex beetween padding-smallest headerbar" style="justify-content: space-between; margin-inline: 0.5rem">
	<a class="flex center">
		<img src="assets/img/logo.jpg" alt="BasicNet" class="logo-header" style="height: 32px" />
	</a>

	<div class="flex center">
		<!-- <mat-icon (click)="toggleCompactMode()" class="hover" matTooltip="Change size">{{ compactMode ? 'zoom_in' : 'zoom_out' }}</mat-icon> -->

		<!-- don't remove notificationSidebarClickNuller -->
		<div class="hover flex center padding-smallest notificationSidebarClickNuller" (click)="togglenotificationsSidebar()">
			<mat-icon
				[matBadge]="notificationBadgeAmount"
				matBadgeColor="warn"
				[matBadgeHidden]="notificationBadgeAmount === 0"
				class="mat-accent notificationSidebarClickNuller">
				notifications
			</mat-icon>
		</div>

		@if (isLogged) {
			<!-- <app-svg-icon (click)="showApps = !showApps" class="flex center hover"></app-svg-icon> -->
			<ui-avatar-image [source]="user" (click)="showUser = !showUser" class="margin-left-small hover userTabClickNuller"></ui-avatar-image>
		} @else {
			<div (click)="login()" class="flex hover">
				<i class="tiny material-icons margin-right-smallest">security</i>
				Login
			</div>
		}
		<!-- <ng-container *ngIf="!isLogged" class="flex column"></ng-container> -->
	</div>
</div>

@if (showApps) {
	<div class="app-overlay padding-small flex column">
		@for (group of dashboard; track group; let i = $index) {
			<div class="margin-bottom-small margin-top-smallest padding-bottom border-bottom">
				@for (item of group; track item) {
					<div class="flex center justify-center">
						<a class="flex column center justify-center" href="{{ item.Url }}" target="{{ item.TargetBlank ? '_blank' : '_self' }}">
							<img src="{{ item.Icon }}" alt="{{ item.Name }}" />
							<span>{{ item.Name }}</span>
						</a>
					</div>
				}
			</div>
		}
	</div>
}

@if (showUser) {
	<div class="user-overlay flex" style="flex-direction: column" ClickOutside (clickOutside)="outsideUserTab($event)">
		<div class="padding-small flex column">
			<div class="flex center">
				<ui-avatar-image [big]="true" [source]="user"></ui-avatar-image>
				<div class="flex column margin-left-small">
					{{ user.FirstName }} {{ user.LastName }}
					<a href="mailto:{{ user.UserName }}">{{ user.UserName }}</a>
				</div>
			</div>
		</div>

		<div class="flex column padding-small" style="flex-direction: column">
			<b>Browse as</b>
			@for (profile of profiles; track profile) {
				<!-- <div *ngFor="let profile of profiles"> -->
				<a
					(click)="changeProfile(profile)"
					class="flex hover line-height-fix"
					[ngClass]="{
						active: user.CurrentProfileId === profile.Id,
						'margin-left-smallest': profile.IsCustom
					}">
					<i class="tiny material-icons margin-right-smallest">
						{{ profile.IsCustom ? 'style' : 'business' }}
					</i>
					{{ profile.ProfileName }}
				</a>
				<!-- </div> -->
			}

			<a class="flex center" [href]="environment.basicAppBaseUrl + '/my-account/preferences'">
				<i class="material-icons tiny margin-right-smallest">add</i>
				<span>Add new custom profile</span>
			</a>
			<div class="border-top padding-small flex column">
				<a
					class="flex center margin-right-smallest"
					[href]="
						environment.baseSSOUrl +
						'/jump/jumpto?goto=http%3A%2F%2Fwww.basicbank.net%2Fbasicbank%2Fbasicbankjump.aspx&where=http%3A%2F%2Fwww.basicbank.net%2Fbasicbank%2FDefault.aspx'
					">
					<i class="material-icons tiny margin-right-smallest">credit_card</i>
					<span>BasicCard</span>
				</a>

				<a class="flex center margin-right-smallest" [href]="environment.basicAppBaseUrl + '/my-account/personal-info?TAB=|2|'">
					<i class="material-icons tiny margin-right-smallest">lock</i>
					<span>Change password</span>
				</a>

				<a class="flex center margin-right-smallest" [href]="environment.basicAppBaseUrl + '/my-account/personal-info?TAB=|3|'">
					<i class="material-icons tiny margin-right-smallest">photo</i>
					<span>Change profile picture</span>
				</a>

				@if (environment.isAuthenticated) {
					<a class="flex center margin-right-smallest hover" (click)="logoff()">
						<i class="material-icons tiny margin-right-smallest">exit_to_app</i>
						<span>Logoff</span>
					</a>
				} @else {
					<a class="flex center margin-right-smallest" [attr.href]="environment.loginUrl">
						<i class="tiny material-icons margin-right-smallest">vpn_key</i>
						<span>Login</span>
					</a>
				}
			</div>
		</div>

		<!-- link in basso -->
		<!--  -->
	</div>
}
